import type { PropsWithChildren } from 'react';
import React from 'react';

import * as styles from './styles';

export const Box: React.FC<PropsWithChildren> = (props) => <div css={styles.box} {...props} />;
export const BoxContainer: React.FC<PropsWithChildren> = (props) => (
  <div css={styles.container} {...props} />
);
export const BoxHeader: React.FC<PropsWithChildren> = (props) => (
  <p css={styles.header} {...props} />
);
export const BoxMessage: React.FC<PropsWithChildren> = (props) => (
  <p css={styles.message} {...props} />
);
